import * as Common from "@sp-crm/core";
import {
    CalendarDate,
    DayOfWeek,
    ITaskBase,
    RecurrencePattern,
    UserId,
} from "@sp-crm/core";
import { PrimaryButton } from "components/ui/primary-button";
import * as React from "react";
import { handleEvent } from "util/user-events";
import { Header } from "../../header";
import { TaskTypeContext } from "../task-type-provider";
import { TaskForm } from "./task-form";

interface NewTaskProps {
    onAddTask: (
        assignedUserId: UserId | null,
        text: string,
        notes: string,
        dueDate: CalendarDate | null,
        dueDateTime: Date | null,
        taskTypeId: Common.TaskTypeId | null,
        recurrencePattern?: RecurrencePattern | null,
        recurrenceInterval?: number | null,
        recurrenceDaysOfWeek?: DayOfWeek[] | null,
        recurrenceDayOfMonth?: number | null,
    ) => void;
    users: Common.User[];
    assignedToId: UserId | null;
}

export const NewTask: React.FC<NewTaskProps> = props => {
    const [isAddingNewTask, setIsAddingNewTask] = React.useState(false);

    const save = (
        assignedUserId: UserId | null,
        text: string,
        notes: string,
        dueDate: CalendarDate | null,
        dueDateTime: Date | null,
        taskTypeId: Common.TaskTypeId | null,
        recurrencePattern?: RecurrencePattern | null,
        recurrenceInterval?: number | null,
        recurrenceDaysOfWeek?: DayOfWeek[] | null,
        recurrenceDayOfMonth?: number | null,
    ) => {
        handleEvent("task-create");
        setIsAddingNewTask(false);
        props.onAddTask(
            assignedUserId,
            text,
            notes,
            dueDate,
            dueDateTime,
            taskTypeId,
            recurrencePattern,
            recurrenceInterval,
            recurrenceDaysOfWeek,
            recurrenceDayOfMonth,
        );
    };

    const cancel = () => {
        setIsAddingNewTask(false);
    };

    const showCreateNewTaskForm = (): JSX.Element => {
        const task: ITaskBase = {
            ownerId: props.assignedToId,
            text: "",
            notes: "",
            dueDate: CalendarDate.todayNoTime,
            dueDateTime: null,
            taskTypeId: null,
            recurrencePattern: null,
            recurrenceInterval: null,
            recurrenceDaysOfWeek: null,
            recurrenceDayOfMonth: null,
        };
        return (
            <div className="tasks-section shadow bg-white">
                <Header iconName="24_TaskNew">Create new task</Header>
                <TaskTypeContext.Consumer>
                    {types => (
                        <TaskForm
                            onSaveTask={save}
                            onCancelTaskChanges={cancel}
                            task={task}
                            saveButtonLabel="Add Task"
                            users={props.users}
                            taskTypes={types}
                        />
                    )}
                </TaskTypeContext.Consumer>
            </div>
        );
    };

    const showNewTaskButton = (): JSX.Element => {
        return (
            <div className="new-task-button">
                <PrimaryButton onClick={() => setIsAddingNewTask(true)}>
                    Create new task
                </PrimaryButton>
            </div>
        );
    };

    if (isAddingNewTask) return showCreateNewTaskForm();
    return showNewTaskButton();
};
